import styled, { css } from 'styled-components';

import Colors from '@rockalingua/ui/constants/Colors';
import { staticCdnHost } from '@rockalingua/ui/constants/Cdn';
import MediaQueryBreakpoints from '../../constants/MediaQueryBreakpoints';

const controlIconWidthPx = 92;
const controlIconHeightPx = 46;
const maskPath = '/img/home/player/01_MASK1.svg';

export const Container = styled.div`
  position: relative;
`;

export const VideoElement = styled.video`
  display: block;
  width: 100%;
  mask-image: url('${staticCdnHost + maskPath}');
  mask-size: cover;
  mask-repeat: no-repeat;
`;

export const Controls = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const ControlButton = styled.button<{ $position: 'left' | 'right' }>`
  width: 30px;
  height: 30px;
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  color: ${Colors.BLUE};
  overflow: hidden;

  ${({ $position }) => {
    if ($position == 'left') {
      return css`
        bottom: 8px;
        left: 10px;

        @media (${MediaQueryBreakpoints.isXsm}) {
          bottom: -2px;
        }
      `;
    } else {
      return css`
        bottom: -8px;
        left: 40px;

        @media (${MediaQueryBreakpoints.isXsm}) {
          bottom: -21px;
        }
      `;
    }
  }}
`;

export const ControlIcon = styled.img`
  position: absolute;
  width: ${controlIconWidthPx}px;
  height: ${controlIconHeightPx}px;
  left: calc(50% - ${controlIconWidthPx / 2}px);
  top: calc(50% - ${controlIconHeightPx / 2}px);
`;
